export default [
  {
    id: 'f1344ecf-6b71-4968-93e8-e1d3906b88bb',
    routeTo: 'anamnesis-abpm',
    alternativeRoute: 'measure-list-abpm',
    reportRoute: 'report-abpm',
    name: 'MAPA - Monitorização Ambulatorial da Pressão Arterial',
    description: 'By Microlife',
    channel: '/connect-to/abpm',
    message: '/device/set-abpm-config',
    messageGet: '/device/get-abpm-config',
    activePropName: 'testAbpm',
    quickTest: false
  },
  {
    id: '89bcd561-6b71-4968-93e8-22d3ed6b88bn',
    routeTo: 'anamnesis-hbpm',
    alternativeRoute: 'measure-list-hbpm',
    reportRoute: 'report-hbpm',
    name: 'MRPA - Monitorização Residencial da Pressão Arterial',
    description: 'By Microlife',
    channel: '/connect-to/hbpm',
    message: '/device/set-hbpm-config',
    messageGet: '/device/get-hbpm-config',
    activePropName: 'testHbpm',
    quickTest: false
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-etd3906b88bb',
    routeTo: 'bloodPressure',
    name: 'Medida da Pressão Arterial',
    description: 'By Microlife',
    channel: '/connect-to/blood-pressure',
    message: '/device/get-blood-pressure',
    activePropName: 'testBloodPressure',
    youtube: '0D9AGlyaBT8',
    quickTest: false
  },
  {
    id: '77bcd56c-9d4c-88bb-41d4-etd39033992f',
    routeTo: 'sprint',
    name: 'Medida Desacompanhada da PA no Consultório',
    description: 'By Microlife',
    channel: '/connect-to/hbpm',
    message: '/device/set-hbpm-config',
    messageGet: '/device/get-hbpm-config',
    activePropName: 'testSprint',
    quickTest: false
  },
  {
    id: '20qcd1fn-9d4c-89bb-5133-phd390992d4',
    routeTo: 'prescription',
    name: 'Prescrição',
    description: 'By Medlevensohn',
    channel: '...',
    message: '...',
    activePropName: 'prescription',
    quickTest: false
  },
  {
    id: 'f1344ecf-6b71-4968-93e8-793cafbe0880',
    routeTo: 'plp',
    name: 'Perfil Lipídico',
    description: 'By Acon Mission',
    channel: '/connect-to/lipid-profile',
    message: '/device/get-lipid-profile',
    activePropName: 'testLipidProfile',
    youtube: '5OvWQiL80to',
    quickTest: false
  },
  {
    id: '89bcd56b-9d4c-41d4-992f-e1d3906b88bb',
    routeTo: 'gc',
    name: 'Glicemia Capilar',
    description: 'By Acon On Call Plus / Wellion Luna Duo',
    channel: '/connect-to/blood-glucose',
    message: '/device/get-blood-glucose',
    activePropName: 'testBloodGlucose',
    youtube: 'Rnptev5ZWv8',
    quickTest: false
  },
  {
    id: '89bcd5vc-9d4c-41d4-992f-etd3906b88bb',
    routeTo: 'totalCholesterol',
    name: 'Colesterol Total',
    description: 'By Wellion Luna Duo',
    channel: '/connect-to/total-cholesterol',
    message: '/device/get-total-cholesterol',
    activePropName: 'testTotalCholesterol',
    youtube: 'Rnptev5ZWv8',
    quickTest: false
  },
  {
    id: '89bcd56c-9d4c-41d4-6b88-e2d390992fbb',
    routeTo: 'psa',
    name: 'Teste Rápido para PSA',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'testPsa',
    quickTest: true
  },
  {
    id: '89bcd56c-6b88-41d4-9d4c-e2d390992fbb',
    routeTo: 'tuberculosis',
    name: 'Teste Rápido para Tuberculose',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'tuberculosis',
    quickTest: true
  },
  {
    id: '89bcd555-86b8-41d4-9d4c-e2d390fza992',
    routeTo: 'strepa',
    name: 'Teste Rápido para Strep A',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'strepa',
    quickTest: true
  },
  {
    id: '89bcd555-86b8-41d4-9d4c-0fza99e2d392',
    routeTo: 'hsv',
    name: 'Teste Rápido para HSV',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'hsv',
    quickTest: true
  },
  {
    id: '89bcd555-86b8-11b1-41d4-39ae2d990fz2',
    routeTo: 'd-dimero',
    name: 'Teste Rápido para D-Dímero',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'ddimero',
    youtube: 'hud2pmygOlY',
    quickTest: true
  },
  {
    id: '89b86555-hlb8-11b1-39ae-41d42d990fz2',
    routeTo: 'mioglobina',
    name: 'Teste Rápido para Mioglobina',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'mioglobina',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e2d3906b88bb',
    routeTo: 'covid19',
    name: 'Coronavírus (COVID-19) IgG/IgM',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'testCovid19',
    youtube: 'k4HMCkpe1v8',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-992f-41d4-e2d3906b88bb',
    routeTo: 'covidAg',
    name: 'Coronavírus (COVID-19) Detecção p/ Antígeno',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'testCovid19Ag',
    youtube: 'FkcQ_nRA2XA',
    quickTest: true
  },
  {
    id: '89bcd56c-94dc-992f-11d4-lkd39bv6b88bb',
    routeTo: 'covidAntiProteinS',
    name: 'Coronavírus (COVID-19) Anticorpos Anti-Proteína S',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'antiProteinS',
    youtube: 'OozD1182okw',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906b68bb',
    routeTo: 'dengue-igg-igm',
    name: 'Dengue IgG/IgM',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'testDengueIggIgm',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906b87bb',
    routeTo: 'dengue-ab-ag',
    name: 'Dengue IgG/IgM/NS1',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'testDengueAbAg',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906b88cc',
    routeTo: 'dengue-ns1',
    name: 'Teste Rápido para Antígeno NS1 Dengue',
    description: 'By MedTeste',
    channel: '...',
    message: '...',
    activePropName: 'testDengueNs1',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906as8bb',
    routeTo: 'adenovirus-rotavirus',
    name: 'Teste Rápido para Adenovírus /Rotavírus Combo',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testAdenovirusRotavirus',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906b88gc',
    routeTo: 'bhcg',
    name: 'Teste Rápido para BHCG',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testBhcg',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-4dd4-992f-1d396b88bb',
    routeTo: 'vitaminD',
    name: 'Teste Rápido Semiquantitativo de Vitamina D',
    description: 'By MedTeste Vitamina D',
    channel: '...',
    message: '',
    activePropName: 'testSemiquantitative',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d390b88ff',
    routeTo: 'chikungunyaIgm',
    name: 'Teste Rápido para Chikungunya IgM',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testChikungunyaIgm',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906b88ff',
    routeTo: 'chikungunyaIggIgm',
    name: 'Teste Rápido para Chikungunya IgG e IgM',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testChikungunyaIggIgm',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906b88bc',
    routeTo: 'influenzaAB',
    name: 'Teste Rápido para Influenza A e Influenza B (H1N1)',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testInfluenzaAb',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906b88cb',
    routeTo: 'hPylori',
    name: 'Teste Rápido para Helicobacter Pylori',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testHPylori',
    youtube: '6rO7q7f9anA',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3906g88bb',
    routeTo: 'hbsag',
    name: 'Teste Rápido para HbsAg',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testHbsag',
    quickTest: true
  },
  {
    id: '89bcdv6c-9d4c-41d4-992f-e1d3906b88bb',
    routeTo: 'hcv',
    name: 'Teste Rápido para HCV',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testHcv',
    quickTest: true
  },
  {
    id: '89bcd561-9d4c-41d4-992f-e1d3906b88bb',
    routeTo: 'hiv',
    name: 'Teste Rápido para HIV',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testHiv',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-995f-e1d3906b88bb',
    routeTo: 'malaria',
    name: 'Teste Rápido para Malária',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testMalaria',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-41d4-992f-e1d3406b88bb',
    routeTo: 'occultBlood',
    name: 'Teste Rápido para Sangue oculto',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testOccultBlood',
    quickTest: true
  },
  {
    id: '89bcd56c-2d4c-41d4-992f-e1d3906b88bb',
    routeTo: 'syphilisIggIgmHiv',
    name: 'Teste Rápido para Sífilis / HIV Combo',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testSyphilisIggIgmHiv',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-4dd4-992f-e1d3906b88bb',
    routeTo: 'zikaIggIgm',
    name: 'Teste Rápido para Zika IgG/IgM',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testZicaIggIgm',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-4dd4-992f-e1d396b88bb',
    routeTo: 'cardiacTroponin',
    name: 'Teste Rápido para Troponina Cardíaca',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testCardiacTroponin',
    youtube: 'XE_WJOsgEAU',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-4dd4-992f-e1d96b88bb',
    routeTo: 'syphilisIggIgm',
    name: 'Teste Rápido para Sífilis',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testSyphilisIggIgm',
    quickTest: true
  },
  {
    id: '89bcd56c-9d4c-4dd4-992f-1d396b88bb',
    routeTo: 'havIggIgm',
    name: 'Teste Rápido para HAV IgG/IgM',
    description: 'By MedTeste',
    channel: '...',
    message: '',
    activePropName: 'testHavIggIgm',
    quickTest: true
  },
  {
    id: '89bcd5vc-9d4c-41d4-992f-etd3906b44cc',
    routeTo: 'glycatedHemoglobin',
    name: 'Hemoglobina Glicada',
    channel: '/connect-to/glycated-hemoglobin',
    message: '/device/get-glycated-hemoglobin',
    activePropName: 'testGlycatedHemoglobin',
    youtube: 'Rnptev5ZWv8',
    quickTest: false
  },
  {
    id: '89bcd5vc-9d4c-41d4-992f-etd3906b44ch',
    routeTo: 'respiratorySyncytial',
    name: 'Teste Rápido para Vírus Sincicial Respiratório (RSV)',
    channel: '...',
    message: '',
    activePropName: 'respiratorySyncytial',
    quickTest: true
  }
]
